// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5d071b5b","496":"74c20300","703":"d956c495"}[chunkId] + ".chunk.js";
};